import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_47s98587ya: FaireBrandEntity = {
  token: "b_47s98587ya",
  type: "brand",
  name: "Oasis Snacks",
  avatarUrl:
    "https://cdn.faire.com/fastly/1cc8f2ef0f9352b10e7fcc0046fc83cc3d8bfc8e55429df04fd3226c0f6e52a9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/adfe39f052fa1fa89f6ae31321d4f0d63b516fd6c87ca7fd198c65d67ec95b3d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1cc8f2ef0f9352b10e7fcc0046fc83cc3d8bfc8e55429df04fd3226c0f6e52a9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/adfe39f052fa1fa89f6ae31321d4f0d63b516fd6c87ca7fd198c65d67ec95b3d.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 173,
  rating: 4.2,
  reviewCount: 153,
  isInsider: true,
  description:
    "Oasis Snacks is more than just tasty snacks and delicious beverages. We're in the business of making time for the important things in life. - Shoppers spend more than 53 hours per year on traditional grocery shopping, and that doesn't factor in the commute to and from your grocery store. Instead of wasting your time in the line at the local market, you could be using to do it the things that you actually want, and Oasis Snacks is here to make that possible.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:46.284Z",
    importedBy: "entity-db-cli",
  },
};
